export default __webpack_public_path__ + "static/media/g2021-6.90562a7c.jpeg";